export const END_POINTS = {
  REWARDS_GROUP: {
    GET_GROUPS: (page, perPage) => `/api/rule-group?page=${page}&perPage=${perPage}`,
    CREATE_GROUP: '/api/rule-group',
    UPDATE_GROUP: '/api/rule-group/',
  },
  REWARDS_CLASS: {
    GET_CLASS: (page, perPage) => `/api/reward-class?page=${page}&perPage=${perPage}`,
    CREATE_CLASS: '/api/reward-class',
    UPDATE_CLASS: '/api/reward-class/',
    GET_MCC_LIST: (page, perPage, search) =>
      `/api/reward-class/list-mcc?page=${page}&perPage=${perPage}&search=${search}`,
    GET_MERCHANT_LIST: (page, perPage, search) =>
      `/api/reward-class/list-merchants?page=${page}&perPage=${perPage}&search=${search}`,
    GET_DEALERSHIPS: (page, perPage, search) => `/api/dealerships?page=${page}&perPage=${perPage}&search=${search}`,
  },
  REWARDS_RULE: {
    GET_RULE: (page, perPage, sortBy) => `/api/reward-rule?page=${page}&perPage=${perPage}&sortBy=${sortBy}`,
    CREATE_RULE: '/api/reward-rule',
  },
  REWARDS_GRANT: {
    GET_CUSTOMER_BY_FINANCIAL_ACCOUNT_ID: '/api/customer-admin/by-financial-account-id/',
    CREATE_GOODWILL_ADJUSTMENT: '/api/reward-admin/goodwill-adjustment',
    CREATE_LOAN_LEASE_ADJUSTMENT: '/api/reward-admin/loan-lease-adjustment',
    GET_MANUAL_ADJUSTMENTS: (page, perPage) => `/api/reward-admin/manual-adjustments?page=${page}&perPage=${perPage}`,
    GET_DML_SCRIPTS: '/api/reward-admin/dml-scripts',
    RUN_DML_SCRIPT: '/api/reward-admin/run-dml-script',
  },
  BUSINESS_ADMIN: {
    BUSINESS: '/api/business-admin/business',
    BUSINESS_LOCATION: '/api/business-admin/business-location',
    BUSINESS_LOCATION_REWARD_CLASS: (businessLocationId, startDate) =>
      `/api/business-admin/business-location/${businessLocationId}/reward-class/${startDate}`,
    BUSINESSES: '/api/business-admin/businesses',
  },
}
